module.exports = __webpack_public_path__ + "img/1572256352(1).b2bce451.jpg";